export default "__VITE_ASSET__tw2IhnDM__"